import { required } from 'vuelidate/lib/validators';

const validations = {
  companyId: {
    required,
  },
  bankId: {
    required,
  },
  bankAccount: {
    required,
  },
};
export default validations;